export const apiUrl = process.env.VUE_APP_API_URL
export const bucketUrl = process.env.VUE_APP_BUCKET_URL
export const appEnv = process.env.VUE_APP_ENV
export const defaultCompanyLogo = process.env.VUE_APP_DEFAULT_COMPANY_LOGO_PATH
export const prodBaseDomain = (process.env.VUE_APP_PROD_BASE_DOMAIN || 'curfox.com').trim()

// Staging url configs
export const stagingBaseDomain = process.env.VUE_APP_STAGING_BASE_DOMAIN
export const stagingTag = (process.env.VUE_APP_STAGING_TAG || '').trim()

// Production: ".int" or "" (normalize also "int" -> ".int")
export const prodInt = (() => {
  const v = (process.env.VUE_APP_PROD_INT || '').trim()
  if (!v) return ''
  return v.startsWith('.') ? v : `.${v}`
})()
